"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    panelContentVariant: ()=>panelContentVariant,
    panelVariants: ()=>panelVariants
});
const tv_cjs_namespaceObject = require("../../variants/tv.cjs");
const panelVariants = (0, tv_cjs_namespaceObject.tv)({
    base: 'border-1 border-primary-5 text-neutral-7 z-1 relative',
    variants: {
        emphasis: {
            default: 'bg-primary-1',
            medium: 'bg-primary-2'
        },
        overflow: {
            hidden: 'overflow-hidden',
            auto: 'overflow-auto',
            scroll: 'overflow-scroll',
            visible: 'overflow-visible'
        },
        borderRadius: {
            none: 'rounded-none',
            sm: 'rounded-sm',
            md: 'rounded-md',
            lg: 'rounded-lg',
            xl: 'rounded-xl',
            '2xl': 'rounded-2xl',
            '3xl': 'rounded-3xl',
            full: 'rounded-full'
        },
        padding: {
            2: 'p-2',
            4: 'p-4',
            6: 'p-6',
            8: 'p-8',
            10: 'p-10',
            12: 'p-12',
            14: 'p-14',
            16: 'p-16',
            20: 'p-20'
        }
    },
    defaultVariants: {
        emphasis: 'default',
        overflow: 'hidden',
        padding: 4,
        borderRadius: 'xl'
    }
});
const panelContentVariant = (0, tv_cjs_namespaceObject.tv)({
    base: 'bg-primary-2 text-xs'
});
exports.panelContentVariant = __webpack_exports__.panelContentVariant;
exports.panelVariants = __webpack_exports__.panelVariants;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "panelContentVariant",
    "panelVariants"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
